import { Link } from 'react-router-dom';

import { type TrackAssessmentCategory, UnlockCard } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';

import { Box, SxProps, Theme } from '@mui/material';

type FourUnlocksGridProps = Readonly<{ unlocks: readonly TrackAssessmentCategory[] }>;

export const FourUnlocksGrid: React.FC<FourUnlocksGridProps> = ({ unlocks }) => (
  <Box sx={containerSx}>
    <Box sx={gridSx}>
      {unlocks.map((unlock) => (
        <Box
          key={unlock.slug}
          component={Link}
          to={APP_ROUTE.LIBRARY}
          id={`success-system-unlock-${unlock.slug}-card`}
          sx={cardLinkSx}
        >
          <UnlockCard variant={{ type: 'TINY', category: unlock }} />
        </Box>
      ))}
    </Box>
  </Box>
);

const containerSx: SxProps<Theme> = {
  containerType: 'inline-size',
};

// Hardcoded: fixed 311px unlock cards; two of them plus the gap need 638px.
const gridSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 311px)',
  justifyContent: 'center',
  gap: backrs.spacing['spacing-xl'],
  '@container (min-width: 638px)': {
    gridTemplateColumns: 'repeat(2, 311px)',
  },
});

const cardLinkSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'block',
  textDecoration: 'none',
  borderRadius: backrs.radius['radius-xl'],
  transition: 'box-shadow 0.2s ease',
  '&:hover, &:focus-visible': {
    boxShadow: backrs.shadows['shadow-md'],
  },
});
